import React from 'react';

export const Arrow = ({ type, onClick, isEdge }) => {
  const pointer = type === 'PREV' ? 'btn_prev.png' : 'btn_next.png';
  return (
    <div className={`self-center ${isEdge ? 'invisible' : 'visible' }`} >
      <img onClick={onClick} className="-mt-10" src={'/images/arrows/'+pointer} alt="Arrow" />
    </div>
  )
}